var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4985 4.7565C26.1703 4.36268 25.7595 4.04594 25.2951 3.82878C24.8308 3.61163 24.3243 3.49937 23.8117 3.5H4.949L4.9 3.0905C4.79972 2.23932 4.39062 1.45452 3.75024 0.884891C3.10986 0.315261 2.28273 0.000398759 1.42567 0L1.16667 0C0.857247 0 0.560501 0.122916 0.341709 0.341709C0.122916 0.560501 0 0.857247 0 1.16667C0 1.47609 0.122916 1.77283 0.341709 1.99162C0.560501 2.21042 0.857247 2.33333 1.16667 2.33333H1.42567C1.71142 2.33337 1.98723 2.43828 2.20077 2.62817C2.41431 2.81805 2.55073 3.07971 2.58417 3.3635L4.1895 17.0135C4.35616 18.4331 5.03822 19.7421 6.10623 20.692C7.17423 21.6419 8.55383 22.1667 9.98317 22.1667H22.1667C22.4761 22.1667 22.7728 22.0438 22.9916 21.825C23.2104 21.6062 23.3333 21.3094 23.3333 21C23.3333 20.6906 23.2104 20.3938 22.9916 20.175C22.7728 19.9562 22.4761 19.8333 22.1667 19.8333H9.98317C9.26107 19.8313 8.55727 19.606 7.96826 19.1882C7.37925 18.7705 6.93387 18.1808 6.69317 17.5H20.5998C21.9675 17.5001 23.2917 17.0196 24.3411 16.1425C25.3905 15.2654 26.0984 14.0475 26.341 12.7015L27.2568 7.62183C27.3483 7.11784 27.3277 6.59991 27.1967 6.10474C27.0656 5.60958 26.8273 5.14929 26.4985 4.7565ZM24.9667 7.20767L24.0497 12.2873C23.904 13.0958 23.4785 13.8273 22.8478 14.3537C22.2171 14.8801 21.4214 15.1679 20.5998 15.1667H6.32217L5.22433 5.83333H23.8117C23.9831 5.83231 24.1526 5.86906 24.3081 5.94096C24.4637 6.01287 24.6015 6.11817 24.7118 6.24938C24.822 6.38058 24.902 6.53447 24.9461 6.70009C24.9902 6.86572 24.9972 7.03902 24.9667 7.20767Z",
    fill: "url(#paint0_linear_16_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16671 28C9.45537 28 10.5 26.9553 10.5 25.6667C10.5 24.378 9.45537 23.3333 8.16671 23.3333C6.87804 23.3333 5.83337 24.378 5.83337 25.6667C5.83337 26.9553 6.87804 28 8.16671 28Z",
    fill: "url(#paint1_linear_16_92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 28C21.122 28 22.1667 26.9553 22.1667 25.6667C22.1667 24.378 21.122 23.3333 19.8333 23.3333C18.5447 23.3333 17.5 24.378 17.5 25.6667C17.5 26.9553 18.5447 28 19.8333 28Z",
    fill: "url(#paint2_linear_16_92)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_92",
    x1: 6.08297,
    y1: -7.97999,
    x2: 28.6771,
    y2: -6.92035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#E4A16F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_92",
    x1: 6.8727,
    y1: 21.6533,
    x2: 10.736,
    y2: 21.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#E4A16F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_92",
    x1: 18.5393,
    y1: 21.6533,
    x2: 22.4026,
    y2: 21.8004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E3928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#E4A16F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.9d60036b7df2c86283e362b5780cf373.svg";
export { ForwardRef as ReactComponent };